$('.announcements-slider').slick({
  dots: false,
  infinite: false,
  arrows: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
});
$(document).on('click','.upsell-add button',function(e){
  e.preventDefault();
  var handle = $(this).attr('data-expanded');
  $('.upsell-options[aria-expanded="'+handle+'"]').addClass('active');
  $('.upsell-options-overlay').addClass('active');
});
$(document).on('click','.atc_button, .upsell-options-overlay',function(e){
  $('.upsell-options').removeClass('active');
  $('.upsell-options-overlay').removeClass('active');
});

function selectCallbackupsell(variant,selector){
}
$('.upsell_product_form_options').each(function(){
  var Productid = $(this).attr('data-product-id');
  var Productdata = JSON.parse($(this).attr('data-product')),
      context = $(this).parent().data('context');
  new Shopify.OptionSelectors('ProductSelect-'+Productid+'_'+context+'',{ product:Productdata, onVariantSelected: selectCallbackupsell, enableHistoryState: true });    
});